import { useMutation } from '@tanstack/react-query';
import { createAreaRequest } from '../requests/createAreaRequest';
import { useNavigate } from 'react-router-dom';
import { AreaFormProps } from '../types/area.type';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useCreateArea() {
	const navigate = useNavigate();

	const createArea = useMutation({
		mutationFn: async (data: AreaFormProps) => {
			return createAreaRequest(data);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully created!', type: 'success' });
			queryClient.invalidateQueries(['AREA_LIST']);
			navigate(-1);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
			queryClient.invalidateQueries(['AREA_LIST']);
		},
	});

	return { createArea };
}
